export const ACTION_SET_AUTH_STATUS = "ACTION_SET_AUTH_STATUS";
